var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallBuilding = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M36.195 35.176V20.12a.909.909 0 0 0-.904-.913h-.451M11.805 35.176V20.58c0-.503.403-.913.904-.913h.905",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.254 26.052h4.516v2.738h-5.872M23.094 26.052h-5.871v2.738h4.516M32.127 17.386h-.904M34.384 33.351v-17.79h-3.161M16.774 15.562h-3.16v17.79M16.774 17.386h-3.16",
  stroke: "#A4ABB7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 22.862c3.243 0 5.872-2.656 5.872-5.931C29.872 13.655 27.243 11 24 11c-3.242 0-5.871 2.655-5.871 5.93 0 3.276 2.629 5.932 5.871 5.932Z",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.899 22.859v9.58a.909.909 0 0 1-.905.913.909.909 0 0 1-.904-.914v-9.58",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.29 15.104h5.417M21.29 16.931h5.417M21.29 18.755H24.9",
  stroke: "#F15B35",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M38 35.176H26.71l-.904.455h-3.612l-.904-.455H10v1.369c0 .251.202.455.45.455h27.096c.25 0 .451-.204.451-.455v-1.37H38Z",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.234.5C37.347.5 47.97 11.026 47.97 24.001c0 12.975-10.623 23.501-23.736 23.501C11.122 47.502.5 36.976.5 24.001.5 11.026 11.122.501 24.234.5Z",
  stroke: "#A4ABB7"
})));
export default SvgSmallBuilding;